import type { Tag } from '../../Tags/Types/tagsType';

export interface ExpenseInvoiceTagLookup {
  id: number;
  name: string;
}

export const mapTagToExpenseInvoiceLookup = (
  tag: Tag | undefined | null
): ExpenseInvoiceTagLookup | undefined => {
  if (!tag) {
    return undefined;
  }

  return {
    id: tag.id,
    name: tag.name,
  };
};
